export default "__VITE_ASSET__5f5c174a__"